<template>
    <div class="container-fluid">

        <SearchView ref="genericSearch" @searchEvent="parentMethod"></SearchView>
        
        <div class="card mb-2">
            <div class="card-header"><h3>Listing</h3></div>
            <div class="card-body">
                <div class="table_responsive">
                    <table class="table m-0 item_table">
                        <thead>
                            <tr>
                                <th><input type="checkbox" value="checkall"/></th>
                                <th v-for="(column, index) in tableHead" :key="index"> {{column.label}}</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, indexprod) in productList" :key="indexprod">
                                    <td><input type="checkbox" v-model="checked[item.id]" :value="item.id" :checked="''"/></td>
                                    <td v-for="(column, indexColumn) in tableColumn" :key="indexColumn">
                                    <a :href="'#'" v-if="tableHead[indexColumn].link==true" @click="send_back(routeName,item.id,item.name, item)" ref="setParent">
                                    {{item[column]}}
                                    </a>
                                    <template v-else>{{item[column]}}</template>
                                    </td>
                                </tr>
                        </tbody>
                    </table>
                </div>
               
            </div>

            <div class="card-footer">
                <div class="d-flex justify-content-end align-items-center">
                    <button
                        :class="pagination.currentPage <= 1 ? 'opacity-50 cursor-not-allowed' : ''"
                        :disabled="pagination.currentPage <= 1"
                        class="btn btn-secondary btn-sm"
                        type="button"
                        @click="changePage(pagination.currentPage - 1,tableHead,tableColumn)"
                    >
                        <i class="fa-solid fa-angle-left"></i>
                    </button> 
                    <span class="mx-2"><span>{{ (pagination.perPage * pagination.currentPage) - pagination.perPage + 1 }}</span>  to <span>{{ pagination.perPage * pagination.currentPage <= pagination.total ? pagination.perPage * pagination.currentPage : pagination.total }}</span> of  <span>{{ pagination.total }}</span></span> 
                    <button
                        :class="pagination.currentPage >= pagination.totalPages ? 'opacity-50 cursor-not-allowed' : ''"
                        :disabled="pagination.currentPage >= pagination.totalPages"
                        class="ml-3 btn btn-secondary btn-sm"
                        type="button"
                        @click="changePage(pagination.currentPage + 1,tableHead,tableColumn)"
                    >
                        <i class="fa-solid fa-angle-right"></i>
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import {ref} from "vue";
import SearchView from "@/components/layout/shared/generic/common/SearchView.vue";

export default {
    name:'popup',
     components:{
        SearchView,
    },
    data() {
        return {
            routeName:null,
            callBack:null,
            tableHead:[],
            tableColumn:[],
            checked:[],
            page: 1,
            search:{},
            sort: {
                order: 'desc',//desc=asc
                column: 'date_entered',
            },
            perPage: 10,
            loading: true,
            productList: [],
            pagination: {
                currentPage: 0,
                perPage: 0,
                total: 0,
                totalPages: 0
            },
            user_type:null,
        }
    },
    mounted() {
        this.getUrls();
        this.loadPopupSearch();
        this.loadPopupView();
    },
    methods:{
        changePage(page,tableHead,tableColumn) {
            const self = this;
            if ((page > 0) && (page <= self.pagination.totalPages) && (page !== self.page)) {
                self.page = page;
                self.loadPopupView(tableHead,tableColumn);
            }
        },
        changeSort() {
            const self = this;
            if (self.sort.order === 'asc') {
                self.sort.order = 'desc';
            } else if (self.sort.order === 'desc') {
                self.sort.order = 'asc';
            }
            self.loadPopupView();
        },
    
        loadPopupSearch(){
            const self = this;
            const searchItem = require(`@/views/modules/${self.moduleName}/metaview/metajs/SearchView.js`);
            self.$refs.genericSearch.loadGenericSearch(searchItem.default);
        },
        getUrls(){
            const urlSearchParams = new URLSearchParams(window.location.search);
            const params = Object.fromEntries(urlSearchParams.entries());
            this.routeName = params.module;
            this.moduleName = params.moduleName;
            this.callBack = params.callback;
            if(params.user_type !='' && typeof params.user_type != undefined){
                this.user_type = params.use_type;
            }
            
        },

         parentMethod(searchRes){
           const self = this;
           self.search = searchRes;
           self.loadPopupView(self.tableHead,self.tableColumn,self.searchArr);
        },
        loadPopupView(){
            const self = this;
            const searchField = require(`@/views/modules/${self.moduleName}/metaview/metajs/PopupField.js`);
            self.tableHead = searchField.default.metaList;
            self.tableColumn = searchField.default.columns;

            if(self.user_type != null){
                self.search.user_type ={key:'user_type',value:self.user_type};
            }

            axios.get('api/modules/'+self.routeName, {
                params: {
                    page: self.page,
                    sort: self.sort,
                    search: self.search,
                    perPage: self.perPage
                }
            }).then(function (response) {
                self.productList = response.data.items;
                self.pagination = response.data.pagination;
                if (self.pagination.totalPages < self.pagination.currentPage) {
                    self.page = self.pagination.totalPages;
                    self.loadPopupView();
                } else {
                    self.loading = false;
                }
            }).catch(function () {
                self.loading = false;
            });
        },
        send_back(routeName, module_id, name, itemObj){
            const modules = routeName.slice(0, -1);
            localStorage.setItem('parentid',module_id);
            localStorage.setItem('parenttype', modules);
            localStorage.setItem('parentname', name);
            localStorage.setItem('parentObj', JSON.stringify(itemObj));
            window.close();
        }
    }
}
</script>
